import { orderBy } from 'lodash'
import { useEffect, useState } from 'react'
import { HomeManualFieldProjection, Sections } from '../definitions'
import fetchApi from '../utils/fetchApi'
import { nameof } from '../utils/languageExtensions'

const { loader } = require('graphql.macro')

const HomeManuals = loader('../queries/HomeManuals.graphql')

type dataType = {
  title: string
  thumbnail: string
  region: {
    name: string
  }
  book: {
    sections: Sections
  }
}

type useHomeManualsState = {
  loading: boolean
  error: boolean
  data: dataType
}

type useHomeManualsProps = {
  homeId: string
}

function useHomeManuals({ homeId }: useHomeManualsProps) {
  const [state, setState] = useState<useHomeManualsState>({
    loading: true,
    error: false,
    data: {} as dataType,
  })

  useEffect(() => {
    fetchApi(HomeManuals, { homeId })
      .then(result => {
        setState({
          loading: false,
          error: false,
          data: {
            ...result.data.home,
            [nameof<dataType>('book')]: {
              sections: orderBy(
                result.data.home.book.sections,
                nameof<HomeManualFieldProjection>('listOrder')
              ),
            },
          },
        })
      })
      .catch(() =>
        setState({
          loading: false,
          error: true,
          data: {} as dataType,
        })
      )
  }, [homeId])

  return state
}

export default useHomeManuals
